import {Component, OnInit} from "@angular/core";
import {Router, ROUTER_DIRECTIVES} from "@angular/router";
import {LoginService} from "./service/login.service";
import {HomePanel} from "./home/home.panel.component";
import {User} from "./domain/user";
import {DROPDOWN_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')],
    directives: [
        ROUTER_DIRECTIVES,
        DROPDOWN_DIRECTIVES
    ],
    precompile: [HomePanel]
})
export class HomeComponent implements OnInit {

    private showLefNavbar:boolean;

    public userLogged:User;
    public userIsAdmin:boolean;
    public userIsClient:boolean;
    public userIsBank:boolean;

    public logoUrl:string;

    constructor(private router:Router,
                private loginService:LoginService) {
        this.init()
    }

    private init():void {
        this.showLefNavbar = false;

        this.userIsAdmin = false;
        this.userIsClient = false;
    }

    public ngOnInit() {
        this.loginService.getUserCredentials().subscribe(
            user => {
                this.userLogged = new User(user);
                this.userIsAdmin = this.userLogged.isAdmin();
                this.userIsClient = this.userLogged.isClient();
                if (this.userLogged.bank && this.userLogged.bank.id && this.userLogged.bank.logo && this.userLogged.bank.logo.id) {
                    this.logoUrl = "/bank/" + this.userLogged.bank.id + "/download";
                }
                this.loginService.setUserLogged(this.userLogged);
                if (this.userLogged && this.userLogged.rol && this.userLogged.rol.name) {
                    if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
                        this.userIsBank = true;
                    }
                }
            },
            ()=> {
                //Do Nothing.
            });
    }

    public goToHome():void {
        this.showLefNavbar = false;
        this.router.navigate(['app/home/adminHome']);
    }

    public goToReports():void {
        this.showLefNavbar = false;
    }

    public goToConfig():void {
        this.router.navigate(['app/home/config']);
    }

    public goToConfigMails():void {
        this.showLefNavbar = false;
        this.router.navigate(['app/home/mailTemplateConfig']);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/home.component.ts
 **/